
export enum ReportType {
    BasicUCR = 1,
    BasicMedicare = 2,
    BasicCombo = 3,
    ComprehensiveCaseReview = 4,
    CausationNecessityReasonableness = 5,
    BillingSummary = 6,
    MedicalChronology = 7,
    MedicalCostProjection = 8,
    OpposingExpertReportReview = 10
}
